import { React, useEffect } from 'react';
import Layout from '../components/Layout';
import data from '../data/data.json';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Program = () => {
  useEffect(() => {
    AOS.init({
      easing: 'ease-in-out',
    });
  }, []);

  return (
    <Layout>
      <section id='kegiatan'>
        <div className='flex flex-col gap-1 justify-center items-center p-4 text-white'>
          <h2 className='text-2xl lg:text-3xl text-yellow-400 font-semibold'>Kegiatan Harian Santri</h2>
          <h1 className='text-3xl lg:text-4xl'>Rumah Tahfidz An-Nuur</h1>
        </div>

        <div className='flex flex-col lg:grid lg:grid-cols-2 gap-4 p-4 lg:px-48 font-inter text-black'>
          {data.kegiatan.map((kegiatan) => (
            <div key={kegiatan.id} className='bg-yellow-500 p-6 shadow-2xl rounded-3xl' id='card' data-aos="flip-down">
              <div className='flex flex-row gap-4'>
                <span>{kegiatan.waktu}</span>
                <span>Rumah Tahfidz An-Nuur</span>
              </div>
              <h1 className='text-2xl'>{kegiatan.judulKegiatan}</h1>
              <div>
                <ul className='list-disc list-outside pl-8'>
                  {kegiatan.isi.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
        <div className='p-4 lg:px-48 font-inter'>
          {data.tambahan.map((tambahan) => (
            <div key={tambahan.id} className='bg-yellow-500 p-6 rounded-3xl' data-aos='fade-up'>
              <h1 className='text-2xl mb-2'>Tambahan</h1>
              <div>
                  <ul className='list-disc list-outside pl-8'>
                    {tambahan.isi.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
            </div>
          ))}
        </div>
      </section>

      <section id='fasilitas'>
      <div className='flex flex-col gap-1 justify-center items-center p-4 text-white'>
          <h3 className='text-2xl text-yellow-400 font-semibold'>Fasilitas</h3>
          <h1 className='text-3xl'>Rumah Tahfidz An-Nuur</h1>
        </div>
        <div className='p-4 lg:px-48 font-inter'>
          <div className='bg-yellow-500 p-6 shadow-2xl rounded-3xl' data-aos='fade-up'>
            {data.fasilitas.map((fasilitas, index) => (
              <div key={index} className='flex flex-col justify-center items-center gap-1'>
                <img src='verify.webp' alt='' className='h-20 w-20' data-aos='flip-up' />
                <h1 className='text-center text-xl'>{fasilitas.fasilitas}</h1>
                <p className='text-center text-md mb-4'>{fasilitas.deskripsi}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Program;
